import React, { useEffect, useState } from 'react';
import Loader from "../../components/Loader"; 
import Paginator from "../../components/Paginator"; 
import ApiService from "../../services/ApiService";
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { Link , useParams } from 'react-router-dom';
import { formatDate  } from '../../utils/helper.js';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const List = () => {
    
    const [isLoader, setIsLoader] = useState(false);
    const [events, setEvents] = useState([]);
    const [pagination, setPagination] = useState({});
    const [currency] = useState(process.env.REACT_APP_CURRENCY);
    const { type } = useParams(); 
    const [apiData, setApiData] = useState({
        search: "",
        daterange: "",
        page: 0,
        type:type
    });
    useEffect(() => {
        // Update apiData with the new type whenever it changes
        setApiData(prevData => ({ ...prevData, type }));
    }, [type]);
    
    useEffect(() => {
        getEvents();
    }, [apiData.page, apiData.search, apiData.daterange,apiData.type]); // Dependency array for re-fetching data

    const getEvents = async () => {
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: "GET",
                url: "events", // Replace with your API endpoint
                data: apiData
            });
            const data = response.data;
            if (data.status) {
                setEvents(data.data);
                setPagination(data.pagination);
            } else {
                toast.error(data.message);
            }
            setIsLoader(false);
        } catch (error) {
            setIsLoader(false);
        }
       
    };

    const handlePageChange = (event) => {
        setApiData(prev => ({ ...prev, page: event }));
    };

    const clearFilter = () => {
        setApiData({
            search: '',
            daterange: '',
            page: 0
        });
    };

    const delData = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'you will not be able to revert it!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonColor: '#9E9B9B',
            cancelButtonText: 'no',
        });

        if (result.isConfirmed) {
            const response = await ApiService.request({
                method: "DELETE",
                url: `events/${id}`, // Replace with your API endpoint
            });
            const data = response.data;
            if (data.status) {
                getEvents();
                toast.success(data.message);
            } else {
                toast.error(data.message);
            }
        }
    };

 

    const updateStatus = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "you want to change its status!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#4BC95F',
            confirmButtonText: 'yes',
            cancelButtonColor: '#9E9B9B',
            cancelButtonText: 'no',
        });

        if (result.isConfirmed) {
            const response = await ApiService.request({
                method: "POST",
                url: `events/status/${id}`, // Replace with your API endpoint
            });
            const data = response.data;
            if (data.status) {
                getEvents();
                toast.success(data.message);
            } else {
                toast.error(data.message);
            }
        }
    };

    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0 text-capitalize">
                             {type}  Events</h1>
                        <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                            <li className="breadcrumb-item text-muted">
                                <Link to="/dashboard" className="text-muted text-hover-primary">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <span className="bullet bg-gray-400 w-5px h-2px"></span>
                            </li>
                            <li className="breadcrumb-item text-muted">Events</li>
                        </ul>
                    </div>
                    <div className="d-flex align-events-center gap-2 gap-lg-3">
                        {/* Add New events Button */}
                        <Link to={`/events/create`}  className='btn btn-base btn-sm'>Add New Event</Link>
                    </div>
                </div>
            </div>
            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-xxl">
                    <div className="card">
                        <div className="card-header border-0 pt-6">
                            <div className="w-100">
                                <form method="get">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="d-flex align-events-center position-relative my-1">
                                                <input type="text" value={apiData.search} onChange={e => setApiData({ ...apiData, search: e.target.value })} className="form-control form-control-solid me-5"
                                                 placeholder={("Search Event title..")} />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <DatePicker
                                                selectsRange={true}
                                                startDate={apiData.daterange[0]}
                                                endDate={apiData.daterange[1]}
                                                onChange={e => setApiData({ ...apiData, daterange: e })} 
                                                isClearable={true}
                                                className='form-control form-control-solid'
                                                placeholderText={('Select Daterange')}
                                            />
                                        </div>
                                        <div className="col-md-3 mt-2">
                                            <button type="button" onClick={clearFilter} className={`btn btn-sm btn-secondary mx-1 ${!apiData.search && !apiData.daterange ? 'd-none' : ''}`}>{("clear")}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="card-body pt-0">
                            <div id="kt_events_table_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                                <div className="table-responsive">
                                    <table className="table align-middle table-hover fs-6 gy-5 dataTable no-footer">
                                        <thead>
                                            <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                                <th>{("Image")}</th>
                                                <th>{("Title")}</th>
                                                <th>{("User")}</th>
                                                <th>{("Status")}</th>
                                                <th>{("Event Date")}</th>
                                                <th>{("Actions")}</th>
                                            </tr>
                                        </thead>
                                        <tbody className="fw-semibold text-gray-600 fs-6">
                                            {events.length > 0 ? events.map((cat, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <img src={cat?.images[0]?.image} alt="img" className="w-80px rounded" />
                                                    </td>
                                                    <td>{cat.title}</td>
                                                    <td>  {cat.user.name ?? ''} <br />
                                                        {cat.user?.email ?? cat.user.phone}

                                                    </td>
                                                    <td>
                                                        <button className="p-0 btn btn-transparent">
                                                            <span className={`badge ${cat.status === 1 ? 'badge-light-success' : 'badge-light-danger'}`} onClick={() => updateStatus(cat.id)} >
                                                                {cat.status === 1 ? 'Active' : 'Inactive'}
                                                            </span>
                                                        </button>
                                                    </td>
                                                    <td>
                                                        {formatDate(cat.created_at,'DD MMM, YYYY')} <br />
                                                        {cat.start_time+ "-"+cat.end_time }


                                                    </td>
                                                    <td className="mt-2">
                                                        <select onChange={()=> updateStatus(cat.id)} value={cat.status} className="form-select w-100px p-2 fs-6" >
                                                            <option value="1">Active</option>
                                                            <option value="0">In Active</option>
                                                        </select>
                                                        <Link to={`/events/${cat.id}`} className="btn btn-sm h-30px btn-light-primary">
                                                            <i className="bi bi-eye-fill fs-6"></i>
                                                        </Link>
                                                        {cat.user.is_admin==1 && 
                                                            <Link to={`/events/create/${cat.id}`} className="btn btn-sm h-30px btn-light-primary">
                                                                <i className="bi bi-pencil-fill fs-6"></i>
                                                            </Link>
                                                        }
                                                        <button  onClick={() => delData(cat.id)} className="btn btn-sm h-30px btn-light-primary">
                                                            <i className="bi bi-trash-fill fs-6"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td colSpan="11" className="text-dark text-center mt-2">No data found!</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table> 
                                    {isLoader && (
                                        <Loader text="Loading" size="30" className="text-center"  />
                                    )}

                                    {pagination.total_pages > 1 && (
                                        <Paginator
                                            page={pagination.current_page}
                                            rows={pagination.per_page}
                                            totalRecords={pagination.total_records}
                                            onPageChange={handlePageChange}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default List;
